import { useCallback, useMemo } from 'react'
import { RRule } from '@guestgoodie/helpers'

import Dropdown from '@/components/ui/Dropdown'
import { MonthType } from '../types'
import { useMonthDayTypes } from '../utils/helpers'
import { MultiNumberSelect } from './MultiNumberSelect'
import { NthWeekdaySelect } from './NthWeekdaySelect'

export function MonthlyOptions({
  value,
  onChangeOption
}: {
  value: RRule
  onChangeOption: (options: Partial<RRule['origOptions']>) => void
}) {
  const monthDayTypes = useMonthDayTypes()

  const bymonthday = useMemo(() => {
    if (!value.origOptions.bymonthday) return null

    return Array.isArray(value.origOptions.bymonthday)
      ? value.origOptions.bymonthday
      : [value.origOptions.bymonthday]
  }, [value.origOptions.bymonthday])

  const monthType = useMemo(() => {
    // We need to do this way so that we still know if the bymonthday should be shown, not ideal but works for now
    if (bymonthday || value.options.bymonthday.length > 0)
      return MonthType.SPECIFIC_DAY
    return MonthType.WEEKDAY
  }, [bymonthday, value.options.bymonthday])

  const onChangeMonthType = useCallback(
    (monthType: MonthType) => {
      if (monthType === MonthType.SPECIFIC_DAY) {
        onChangeOption({
          bymonthday: [],
          byweekday: undefined
        })
      }

      if (monthType === MonthType.WEEKDAY) {
        onChangeOption({
          byweekday: [RRule.MO.nth(1)],
          bymonthday: undefined
        })
      }
    },
    [onChangeOption]
  )

  return (
    <div className="flex flex-col gap-1">
      <Dropdown
        options={monthDayTypes}
        value={monthType}
        onChange={onChangeMonthType}
      />
      {monthType === MonthType.SPECIFIC_DAY && (
        <MultiNumberSelect
          value={bymonthday}
          onChange={bymonthday => onChangeOption({ bymonthday })}
          type="days"
        />
      )}
      {monthType === MonthType.WEEKDAY && (
        <NthWeekdaySelect
          value={value.origOptions.byweekday}
          onChange={byweekday => onChangeOption({ byweekday })}
        />
      )}
    </div>
  )
}
